module.exports = __webpack_public_path__ + "static/media/backofficeapp.600ce595.png";